const woman_tops_table = [
  ['한국 <span>(KR)</span>', 'XXS', 'XS', 'S', 'M', 'L', 'XL'],
  ['한국 <span>(KR)</span>', '44(80)', '44-55(85)', '55(90)', '66(95)', '77(100)', '88(105)'],
  ['유럽 <span>(EU)</span>', '32', '34', '36', '38', '40', '42'],
  ['이태리 <span>(IT)</span>', '36', '38', '40', '42', '44', '46'],
  ['미국 <span>(US)</span>', '0', '2', '4', '6', '8', '10'],
];

const woman_bottoms_table = [
  ['허리 <span>(inch)</span>', '24', '24-26', '27-29', '30-31', '32-33', '34-35'],
  ['한국 <span>(KR)</span>', 'XXS(44-55)', 'XS(55-66)', 'S(55-66)', 'M(66-77)', 'L(66-77)', 'XL(77-88)'],
  ['유럽 <span>(EU)</span>', '34', '36', '38', '40', '42', '44'],
  ['이태리 <span>(IT)</span>', '38', '40', '42', '44', '46', '48'],
  ['미국 <span>(US)</span>', '0', '2', '4-6', '8-10', '12', '14'],
];

const man_tops_table = [
  ['한국 <span>(KR)</span>', 'XS', 'S', 'M', 'L', 'XL'],
  ['한국 <span>(KR)</span>', '85', '90', '95', '100', '105'],
  ['유럽 <span>(EU)</span>', '34', '36', '38', '40', '42'],
  ['이태리 <span>(IT)</span>', '44', '46', '48', '50', '52'],
  ['미국 <span>(US)</span>', '14', '15', '16', '16.5-17', '17-17.5'],
];

const man_bottoms_table = [
  ['허리 <span>(inch)</span>', '28-29', '30-31', '32-33', '34-35', '36-37'],
  ['한국 <span>(KR)</span>', 'XS', 'S', 'M', 'L', 'XL'],
  ['유럽 <span>(EU)</span>', '44', '46', '48', '50', '52'],
  ['이태리 <span>(IT)</span>', '44', '46', '48', '50', '52'],
];

const shoes_table = [
  [
    '한국 <span>(mm)</span>',
    '220',
    '225',
    '230',
    '235',
    '240',
    '245',
    '250',
    '255',
    '260',
    '265',
    '270',
    '275',
    '280',
    '285',
    '290',
    '295',
    '300',
  ],
  [
    '유럽 <span>(여)</span>',
    '35',
    '35.5',
    '36',
    '36.5',
    '37',
    '37.5',
    '38',
    '38.5',
    '39',
    '39.5',
    '40',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
  ],
  [
    '유럽 <span>(남)</span>',
    '-',
    '-',
    '-',
    '-',
    '-',
    '38.5',
    '39',
    '40',
    '40.5',
    '41',
    '42',
    '42.5',
    '43',
    '44',
    '44.5',
    '45.5',
    '46',
  ],
  [
    '미국 <span>(여)</span>',
    '5',
    '5.5',
    '6',
    '6.5',
    '7',
    '7.5',
    '8',
    '8.5',
    '9',
    '9.5',
    '10',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
  ],
  [
    '미국 <span>(남)</span>',
    '-',
    '-',
    '-',
    '-',
    '-',
    '6.5',
    '7',
    '7.5',
    '8',
    '8.5',
    '9',
    '9.5',
    '10',
    '10.5',
    '11',
    '11.5',
    '12',
  ],
  [
    '영국 <span>(여)</span>',
    '2.5',
    '3',
    '3.5',
    '4',
    '4.5',
    '5',
    '5.5',
    '6',
    '6.5',
    '7',
    '7.5',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
  ],
  [
    '영국 <span>(남)</span>',
    '-',
    '-',
    '-',
    '-',
    '-',
    '5.5',
    '6',
    '6.5',
    '7',
    '7.5',
    '8',
    '8.5',
    '9',
    '9.5',
    '10',
    '10.5',
    '11',
  ],
];

export enum TabName {
  woman = '여성의류',
  man = '남성의류',
  shoes = '신발',
}

export const tab_list = [TabName.woman, TabName.man, TabName.shoes];

export const overseas_direct_purchase_size_tab = {
  [TabName.woman]: [
    { title: '상의', table: woman_tops_table },
    { title: '하의', table: woman_bottoms_table },
  ],
  [TabName.man]: [
    { title: '상의', table: man_tops_table },
    { title: '하의', table: man_bottoms_table },
  ],
  [TabName.shoes]: [{ table: shoes_table }],
};
